/**
 * Button names to be used for theme role overrides if required
 */
export enum ButtonName {
  AddToBagButton = 'addToBagButton',
  BagDrawerCheckoutButton = 'bagDrawerCheckoutButton',
  BagDrawerViewBagButton = 'bagDrawerViewBagButton',
  BagButton = 'bagButton',
  EmptyBagMessageCardButton = 'emptyBagMessageCardButton',
  ShareDialogButton = 'shareDialogButton',
  CheckoutQuantityControl = 'checkoutQuantityControl',
  MembershipButton = 'membershipButton',
  ProfileButton = 'profileButton',
  LocationMapSearchButton = 'locationMapSearchButton',
  LocationMapSearchResultsButton = 'locationMapSearchResultsButton',
  AddToBagModalButton = 'addToBagModalButton',
}

export enum DTCComponentName {
  EmptyBagMessageCard = 'emptyBagMessageCard',
}
